import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { ListAlertPayload, ListAlertResponse } from './alert-list.types';
import { transformIntoQueryParamString } from '@old/utils/service';

export async function listAlertService({ query: rawQuery }: ListAlertPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.get<ListAlertResponse>(ENDPOINT.ALERTS, { query });

  return {
    response,
    summary: data,
  };
}
